// extracted by mini-css-extract-plugin
module.exports = {"ManualCard":"ManualCard_ManualCard__3Jxii","ManualCard__button":"ManualCard_ManualCard__button__ykxBt","ManualCard__buttonIconLeft":"ManualCard_ManualCard__buttonIconLeft__2oQ2T"};